import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { UserStripeSubscriptionsState } from 'store/userStripeSubscriptions/types';

export const getUserStripeSubscriptionsState = (state: RootState): UserStripeSubscriptionsState =>
  state.userStripeSubscriptions;

export const getUserStripeSubscriptionsData = createSelector(
  [getUserStripeSubscriptionsState],
  (state: UserStripeSubscriptionsState) => state?.data || []
);
